/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogitem_Action1Inputs */

const id_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksi`)
};

const ms_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan`)
};

const da_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handling`)
};

const de_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion`)
};

const en_us2_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const es_es2_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción`)
};

const es_mx2_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción`)
};

const fil_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksyon`)
};

const fr_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const it_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azione`)
};

const hu_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Művelet`)
};

const nl_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actie`)
};

const no_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handling`)
};

const pl_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akcja`)
};

const pt_br2_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const pt_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ação`)
};

const ro_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acțiune`)
};

const fi_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toiminto`)
};

const sv_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åtgärd`)
};

const vi_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hành động`)
};

const tr_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşlem`)
};

const cs_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce`)
};

const bg_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действие`)
};

const ru_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действие`)
};

const uk_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дія`)
};

const ar_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإجراء`)
};

const hi_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्रवाई`)
};

const th_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การดำเนินการ`)
};

const ja_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const zh_cn2_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const zh_hant1_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const ko_components_changelogitem_action1 = /** @type {(inputs: Components_Changelogitem_Action1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Components_Changelogitem_Action1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogitem_action1 = /** @type {((inputs?: Components_Changelogitem_Action1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogitem_Action1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogitem_action1(inputs)
	if (locale === "ms") return ms_components_changelogitem_action1(inputs)
	if (locale === "da") return da_components_changelogitem_action1(inputs)
	if (locale === "de") return de_components_changelogitem_action1(inputs)
	if (locale === "en-US") return en_us2_components_changelogitem_action1(inputs)
	if (locale === "es-ES") return es_es2_components_changelogitem_action1(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogitem_action1(inputs)
	if (locale === "fil") return fil_components_changelogitem_action1(inputs)
	if (locale === "fr") return fr_components_changelogitem_action1(inputs)
	if (locale === "it") return it_components_changelogitem_action1(inputs)
	if (locale === "hu") return hu_components_changelogitem_action1(inputs)
	if (locale === "nl") return nl_components_changelogitem_action1(inputs)
	if (locale === "no") return no_components_changelogitem_action1(inputs)
	if (locale === "pl") return pl_components_changelogitem_action1(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogitem_action1(inputs)
	if (locale === "pt") return pt_components_changelogitem_action1(inputs)
	if (locale === "ro") return ro_components_changelogitem_action1(inputs)
	if (locale === "fi") return fi_components_changelogitem_action1(inputs)
	if (locale === "sv") return sv_components_changelogitem_action1(inputs)
	if (locale === "vi") return vi_components_changelogitem_action1(inputs)
	if (locale === "tr") return tr_components_changelogitem_action1(inputs)
	if (locale === "cs") return cs_components_changelogitem_action1(inputs)
	if (locale === "bg") return bg_components_changelogitem_action1(inputs)
	if (locale === "ru") return ru_components_changelogitem_action1(inputs)
	if (locale === "uk") return uk_components_changelogitem_action1(inputs)
	if (locale === "ar") return ar_components_changelogitem_action1(inputs)
	if (locale === "hi") return hi_components_changelogitem_action1(inputs)
	if (locale === "th") return th_components_changelogitem_action1(inputs)
	if (locale === "ja") return ja_components_changelogitem_action1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogitem_action1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogitem_action1(inputs)
	return ko_components_changelogitem_action1(inputs)
});
export { components_changelogitem_action1 as "components.changelogItem.action" }